import React, {Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {request} from "../../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import Table from "../../../components/Table/Table";
import MiniButton from "../../../components/MiniButton";
import Alert from "react-s-alert";
import SquareButtonX from "../../../components/SquareButtonX";
import '../Customer.css';
import StickButton from "../../../components/StickButton";

class CustomerNotesModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            content: [],
            loading: false,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            alert: null,
            note: [],
            saveButton: false
        };

        this.fetchNotes = this.fetchNotes.bind(this);
        this.onChange = this.onChange.bind(this);
        this.deleteNote = this.deleteNote.bind(this);
        this.addNote = this.addNote.bind(this);
        this.saveNote = this.saveNote.bind(this);
        this.preventNull = this.preventNull.bind(this);
    }

    addNote() {
        let self = this;
        let content = deepCopyObject(self.state.content)
        content.push({
            note: "",
            userName: self.props.currentUser.username,
            editDate: null,
            customerId: self.props.customer.recordId
        })
        self.setState({content: content})
    }

    fetchNotes(accessor, direction, page, size) {
        let self = this;
        if (!page && page !== 0) {
            if (self.state.page) {
                page = self.state.page;
            } else {
                page = 0;
            }
        }

        if (!size) {
            if (self.state.size) {
                size = self.state.size;
            } else {
                size = 10;
            }
        }
        let url = '/customer/fetchCustomerNotes?page=' + page + '&size=' + size;
        let params = {
            url: url,
            method: "post",
            data: self.props.customer.recordId
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        request(params)
            .then(function (response) {
                self.setState({
                    content: response.data.content,
                    manual: false,
                    loading: false,
                    page: page,
                    size: size,
                    total: response.data.totalElements
                });
            }).catch(function (error) {
            showAxiosError(error);
            self.setState({manual: false, loading: false})
        });
    }

    preventNull() {
        let isNoteExists = true;
        this.state.content.map((cnt) => {
            if (cnt.note === null || cnt.note === undefined || cnt.note === "") {
                isNoteExists = false;
            }
        });
        return isNoteExists;
    }

    onChange(e, index) {
        let content = deepCopyObject(this.state.content)
        content[index].note = e.target.value
        this.setState({content, saveButton: true})
    }

    deleteNote(row,index) {
        let self = this;
        self.setState({alert: null});
        let params = {
            url: "/customer/deleteCustomerNote",
            method: "post",
            data: row
        };
        if(this.preventNull()) {
            request(params)
                .then(function (response) {
                    Alert.success("Kayıt başarıyla silindi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                    self.setState({manual: true}, () => self.fetchNotes(self.state.page, self.state.size));
                }).catch(function (error) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
            });
        }
        else{
            let content = deepCopyObject(this.state.content)
            content.splice(index, 1)
            this.setState({content, saveButton: false})
        }
    }

    saveNote() {
        let self = this;
        self.setState({saveButton:false})
            let params = {
                url: `/customer/addCustomerNote`,
                method: 'post',
                data: self.state.content
            };
        if(this.preventNull()) {
            request(params)
                .then(function (response) {
                    Alert.success('Not başarıyla kaydedildi.', {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000,
                        html: false
                    });
                    self.setState({
                        saveButton: false,
                        content: [],
                        index: (self.state.index) + 1
                    }, () => self.fetchNotes(self.state.page, self.state.size));
                }).catch(function (error) {
                self.setState({saveButton: true});
                showAxiosError(error);
            });
        }
        else{
            Alert.error('Not alanını doldurunuz.', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html:false
            });
        }
    }
    render() {

        let columns = [
            {
                Header: "Not",
                title:'Not',
                accessor: "note",
                sortable: false,
                width: "50%",
                Cell: (row,index) => (
                    <div>
                        <textarea
                            className="requestForm-textarea"
                            value={row.note}
                            onChange={(e) => {
                                this.onChange(e, index)
                            }}
                            style={{width: '100%', paddingBottom: 'inherit'}}
                            maxLength={255}
                        />
                    </div>
                )
            },
            {
                Header: "Kullanıcı Adı",
                title: "userName",
                accessor: "userName",
                width: "20%",
                sortable: false
            },
            {
                Header: "Notu Sil",
                accessor: "",
                sortable: false,
                width: "10%",
                Cell: (row,index) => (
                    <div>
                        <MiniButton title="Sil" faIcon="fa-trash" color="danger"
                                    onClick={() => this.deleteNote(row,index)}/>
                    </div>
                )
            }
        ];

        return (
            <div>
                <Modal isOpen={this.props.isOpen} size='lg'>
                    <ModalHeader toggle={()=>this.props.toggle()}>Notlar</ModalHeader>
                    <ModalBody  style={{paddingTop: '4px'}} >
                            <div style={{paddingLeft: '15px'}} >
                                <SquareButtonX position="leftSide"
                                               onClick={this.addNote}
                                               img="plus_sign.png"
                                               label="Not Ekle" />
                                {this.state.saveButton &&
                                    <StickButton position="leftSide"
                                                 title="Kaydet"
                                                 style={{paddingLeft: '15px', paddingRight: '15px'}}
                                                 className="stickButton save"
                                                 icon='save'
                                                 label='Kaydet'
                                                 onClick={() => this.saveNote()}/>
                                }

                            </div>
                        <div className="col-sm-12 row" style={{right: '-15px'}}>
                            <Table columns={columns}
                                   content={this.state.content}
                                   total={this.state.total}
                                   page={this.state.page}
                                   size={this.state.size}
                                   loading={this.state.loading}
                                   options={["5", "10", "20", "50", "100"]}
                                   fetchData={this.fetchNotes}
                                   manual={this.state.manual}
                                   paginationEnabled={true}
                            />
                        </div>

                    </ModalBody>
                    <ModalFooter></ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default CustomerNotesModal;